import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BellRinging03 = function BellRinging03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.0002 19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3m4.7966-12.7614A2.492 2.492 0 0 0 14.5002 4.5c0-1.3807-1.1192-2.5-2.5-2.5s-2.5 1.1193-2.5 2.5c0 .6756.268 1.2886.7035 1.7386M2.5471 8.323c-.0144-1.4514.7681-2.8067 2.0322-3.52m16.8741 3.52c.0144-1.4514-.7681-2.8067-2.0322-3.52m-1.421 6.397c0-1.3791-.6321-2.7018-1.7573-3.677C15.1177 6.548 13.5915 6 12.0002 6s-3.1174.5479-4.2426 1.523c-1.1252.9752-1.7573 2.298-1.7573 3.677 0 2.2818-.566 3.9506-1.272 5.1447-.8047 1.3609-1.207 2.0414-1.1912 2.2039.0182.186.0517.2447.2025.355C3.8714 19 4.5338 19 5.8584 19h12.2837c1.3246 0 1.987 0 2.1188-.0964.1508-.1103.1843-.169.2025-.355.0159-.1625-.3865-.843-1.1912-2.2039-.7061-1.1941-1.272-2.8629-1.272-5.1447"
    })
  }));
};
export default BellRinging03;